import { render, staticRenderFns } from "./corner.vue?vue&type=template&id=7bfcc306&scoped=true"
import script from "./corner.vue?vue&type=script&lang=js"
export * from "./corner.vue?vue&type=script&lang=js"
import style0 from "./corner.vue?vue&type=style&index=0&id=7bfcc306&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bfcc306",
  null
  
)

export default component.exports